import { ClientEnvironment, FooterNavigation } from '@thehubz/client/core';

export const vorwerkFooterConfig = (env?: ClientEnvironment): FooterNavigation[] => {
  return [
    {
      navLink: [env?.brandConfig?.navigation?.imprintUrl ?? '/content/imprint'],
      navText: $localize`:footer navigation:Imprint`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.privacyUrl ?? '/content/privacy'],
      navText: $localize`:footer navigation:Privacy policy`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.supportUrl ?? '/content/support'],
      navText: $localize`:footer navigation:Support`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.termsUrl ?? '/content/terms-of-use'],
      navText: $localize`:footer navigation:Terms of Use`,
    },
  ];
};
